module.exports = __webpack_public_path__ + "img/img47.004d6b8e.svg";